import {
    isInternational
} from '../global/_checkForInternational';
import Pikaday from 'pikaday'

const popupPrint = (eCardID, viewType) => {
    var url = "/webapp/wcs/stores/servlet/PrintEcardDisplay?storeId=301&catalogId=301&langId=-1&eCardId=" + eCardID + "&viewType=" + viewType,
        name = "Print",
        features = "scrollbars=yes,width=1030,height=780,screenX=20,screenY=20,top=20,left=20",
        myWindow = window.open(url, name, features);
    myWindow.focus();
}

const eGiftcard = () => {
    if ($('.wrapper-egift-card').length > 0) {
        if ($('.futureDateBox').is(':checked') && $('.dateOptions').is(':hidden')) $('.dateOptions').toggle();
        var carousel = $('#gift-card-carousel');
        carousel.on('afterChange', function(event, slick, currentSlide) {
            var activeElement = $('#gift-card-carousel .slick-center'),
                cardValue = activeElement.find('img').attr('alt');
            $('#type-of-card option').prop("selected", false);
            $('#type-of-card option[value="' + cardValue + '"] ').prop('selected', 'selected');
        });
        
        $("#gift-card-carousel .item.slick-slide").on("click",function(){
        	carousel.slick('slickGoTo', $('#type-of-card option[value="' + $(this).data("hash") + '"]').data('egift') - 1);
        })
        $('#type-of-card').on('change', function() {
            carousel.slick('slickGoTo', $('#type-of-card option[value="' + $(this).val() + '"]').data('egift') - 1);
        });
        ($(".mobilePage").length > 0) ? $('.input-section').css('min-height', '100%'): $('.input-section').css('min-height', '290px');
        var field = document.getElementById('datepicker'),
            picker = new Pikaday({
                onSelect: function(date) {
                    field.value = picker.toString();
                    $("#sendDateFormatted").val(date.toJSON().substr(0, 10));
                },
                bound: true,
                minDate: new Date()
            });
        picker.gotoToday();
        field.parentNode.insertBefore(picker.el, field.nextSibling);
        var todayFormatted = new Date().toJSON().substr(0, 10);
        $("#sendDateFormatted").val(todayFormatted);
        $("#datepicker").val(todayFormatted);
        $('.futureDateBox').on('change', function(event) {
            $('.dateOptions').toggle();
        });
    }
};

export {
    eGiftcard,
    popupPrint
}
